var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDevelopmentV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342.2 105.9",
    style: {
      enableBackground: "new 0 0 342.2 105.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.7,46.2c-0.4-8.9-0.8-17.7-1.2-26.6c3.7-0.7,8-1.2,10.8,1.4c2.4,2.3,2.4,6.6,0.2,9.2 c-2.2,2.5-6.1,3.2-9.3,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2,32.7c3.7-0.7,8-1.2,10.8,1.4c2.4,2.3,2.4,6.6,0.2,9.2c-2.2,2.5-6.1,3.2-9.3,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.5,20.9c3.1,7.8,5.8,15.7,8.1,23.8c0.4-4.5,1.2-9,2.4-13.4c1-3.6,2.7-6.7,3-10.4c-0.1,0.3,0.1-0.3,0,0 c3.1,7.8,7,15.7,9.3,23.8c0.4-4.5,1.2-9,2.4-13.4c1-3.6,2.2-7.1,2.5-10.8c-0.1,0.3-0.1,0.6-0.1,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.3,22.8c-1.5,6.7,0.5,13.8-0.3,20.7c2.4-0.1,4.9-0.1,7.4-0.2c0.1,0,0.3,0,0.4-0.1c0.1-0.1-0.1-0.3-0.2-0.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.3,32.2c3.1,0.4,6.2,0.4,9.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.3,32.2c3.1,0.4,6.2,0.4,9.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.3,32.2c3.1,0.4,6.2,0.4,9.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.7,22.4c2.8-0.7,5.8-0.8,8.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.9,61.7c3.7-1.3,7.7-1.9,11.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.3,62.1c-1.1,7-1.4,14.1-0.8,21.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.4,83.9c0-8.1,0-16.1,0.5-24.5c2,8.6,7.8,15.7,11.3,23.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.3,60.5c0.1,7.2,0.2,14.4,0.3,21.5c0,0.2,0,0.4,0.2,0.5s0.3-0.3,0.1-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.3,60.2c-1.4-0.6-3,0-4.1,1c-1.1,1-1.7,2.4-2.2,3.8c-1.3,3.6-1.9,7.5-1.8,11.4c0.1,2.1,0.4,4.2,1.6,5.9 s3.5,2.7,5.4,1.9c1.9-0.8,2.7-2.9,3.2-4.9c0.8-2.9,1.4-5.8,1.8-8.8c0.3-2.1,0.4-4.4-0.3-6.4C173.2,62.2,171.2,60.6,170.3,60.2 L170.3,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.2,86.2c-0.4-8.9-0.8-17.7-1.2-26.6c3.7-0.7,8-1.2,10.8,1.4c2.4,2.3,2.4,6.6,0.2,9.2 c-2.2,2.5-6.1,3.2-9.3,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.6,60.6c-0.1,7.8,0.1,15.6,0.6,23.4c3.5-1.1,7.2-1.4,10.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.5,60.6c3.1,7.8,5.8,15.7,8.1,23.8c0.4-4.5,1.2-9,2.4-13.4c1-3.6,2.2-7.1,2.5-10.8 c-0.1,0.3-0.1,0.6-0.1,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.3,61.8c0.5,7.3,1,14.5,1.5,21.7c3.4-0.9,6.8-1.7,10.3-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.7,72.6c2.2-0.1,4.4-0.3,6.5-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.7,62.2c2.9-0.4,5.9-0.7,8.8-1.1c0.2,0,0.5,0,0.5,0.2c0.1,0.2-0.4,0.2-0.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,62.4c-1.5,6.7,0.5,13.8-0.3,20.7c2.5-0.1,4.9-0.1,7.4-0.2c0.2,0,0.3,0,0.4-0.2s-0.1-0.3-0.2-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,71.8c3.1,0.4,6.2,0.4,9.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,71.8c3.1,0.4,6.2,0.4,9.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,71.8c3.1,0.4,6.2,0.4,9.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,62.1c2.8-0.7,5.8-0.8,8.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.7,62.4c-1.5,6.7,0.5,13.8-0.3,20.7c2.4-0.1,4.9-0.1,7.4-0.2c0.2,0,0.3,0,0.4-0.2s-0.1-0.3-0.2-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,71.8c3.1,0.4,6.2,0.4,9.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,71.8c3.1,0.4,6.2,0.4,9.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,71.8c3.1,0.4,6.2,0.4,9.3,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.2,62.1c2.8-0.7,5.8-0.8,8.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,84.5l-0.9-24.4c1.5,0.1,3,0.2,4.4,0.3c1.5,0.1,3,0.2,4.3,0.9c2.5,1.4,3.5,4.5,3.9,7.3 c0.4,2.9,0.5,5.9,0.1,8.9c-0.1,0.9-0.3,1.9-0.7,2.7c-0.8,1.6-2.6,2.6-4.4,3C27.6,83.7,25.5,83.7,22.8,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,86.8c0.2-9.1,0.3-18.3,0.5-27.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.4,87.4c-0.8-9.5-0.8-19-0.1-28.5L224,79.9l-9.6-20.4"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1 animate-svg-no-children",
    d: "M9.4,12.7C117.3,6.9,225.6,7,333.6,13c1.4,28.5,0.5,57.1-2.8,85.5C223,93.8,115,92.3,7.2,97.3 c-0.5-20.9,1-41.7,0.5-62.6C7.5,26.3,8.8,17.2,9.4,12.7z",
    style: {
      animationDelay: "5s",
      animationDuration: "1s"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopmentV2);
export default __webpack_public_path__ + "static/media/web-development-v2.6096f56d10a83d691e17c5381fd5c087.svg";
export { ForwardRef as ReactComponent };